<div class="contact">
    <div class="warp-start">
        <div class="circle">
            <p> {{ contact?.firstName ? contact?.firstName?.charAt(0)?.toUpperCase() : '' }}</p>
            <p>{{ contact?.lastName ? contact?.lastName?.charAt(0)?.toUpperCase() : '' }}</p>
        </div>
        <div class="deatails">
        <div class="name">
            <p>{{contact?.firstName}}</p>
            <p>{{contact?.lastName}}</p>
        </div>
        <div class="email">
            <p>{{contact?.email}}</p>
        </div>
    </div>
    </div>
    <div class="delete pointer" (click)="delete()" *ngIf="!isGroup&&canDelete">
        <img src="/assets/images/popup-recipient/delete.svg">
    </div>
</div>